import { QueryResult, useQuery } from "@apollo/client";
import { LOAD_FARM_GNET_AFFILIATES_QUERY } from "./gnetAffiliates.graphql";

export type GnetAffiliate = {
  id: string;
  operatorName: string;
  operatorEmail: string;
  operatorPhone: string;
  operatorAddress: string;
  contactName: string;
  serviceArea: string;
  gnetId: string;
};

export type LoadFarmGnetAffiliatesConnection = {
  totalCount: number;
  pageInfo: {
    endCursor: string;
    hasNextPage: boolean;
  };
  edges: Array<{
    node: GnetAffiliate;
  }>;
};

type UseLoadFarmGnetAffiliatesQueryParams = {
  shouldSkip?: boolean;
};

function useLoadFarmGnetAffiliatesQuery(
  params: UseLoadFarmGnetAffiliatesQueryParams = {}
): QueryResult<{
  loadFarmGnetAffiliates: LoadFarmGnetAffiliatesConnection;
}> {
  const { shouldSkip } = params;

  return useQuery<{
    loadFarmGnetAffiliates: LoadFarmGnetAffiliatesConnection;
  }>(LOAD_FARM_GNET_AFFILIATES_QUERY, {
    variables: {
      limit: 20,
    },
    fetchPolicy: "network-only",
    skip: shouldSkip,
  });
}

export default useLoadFarmGnetAffiliatesQuery; 